import React from 'react';
import UpdateOdometerBottomSheet from '@di-shared/features/diag/UpdateOdometerBottomSheet';
import BottomSheetWebViewWrapper from '@di-shared/features/common/BottomSheetWebViewWrapper';

const BOTTOM_SHEET_FALLBACK_HEIGHT = 500;

export default function UpdateOdometerBottomSheetPage() {
  return (
    <BottomSheetWebViewWrapper bottomSheetFallbackHeight={BOTTOM_SHEET_FALLBACK_HEIGHT}>
      <UpdateOdometerBottomSheet />
    </BottomSheetWebViewWrapper>
  );
}
